// API Endpoints configuration
export class ApiEndpoints {
  // Base endpoints
  static readonly API_VERSION = "v1";

  // Song endpoints - Gerçek API'ye göre düzeltildi
  static readonly SONGS = "/songs"; // GET all songs (gerçek endpoint)
  static readonly SONG_SEARCH = "/songs/search"; // GET search endpoint
  static readonly MY_SONGS = "/songs/my-songs"; // Normal user endpoint
  static readonly ASSIGNED_SONGS = "/songs/assigned"; // Normal user endpoint
  static readonly SONG_SUGGESTIONS = "/songs/suggestions"; // Normal user endpoint
  static readonly MY_STATS = "/songs/my-stats"; // Normal user endpoint  // Song Request endpoints - Normal User
  static readonly SONG_REQUESTS = "/song-requests"; // POST (create), GET /my (user's requests)
  static readonly MY_SONG_REQUESTS = "/song-requests/my"; // GET user's requests

  // Song Request endpoints - Admin
  static readonly ADMIN_SONG_REQUESTS = "/song-requests/admin/all"; // GET all requests
  static readonly ADMIN_SONG_REQUEST_STATS = "/song-requests/admin/stats"; // GET stats
  static readonly ADMIN_SONG_REQUEST_STATUS = "/song-requests/admin"; // PUT /{id}/status
  static readonly ADMIN_SONG_REQUEST_APPROVE = "/song-requests/admin"; // POST /{id}/approve
  static readonly ADMIN_SONG_REQUEST_REJECT = "/song-requests/admin"; // POST /{id}/reject

  // Beat endpoints - Gerçek API'ye göre düzeltildi
  static readonly BEATS = "/beats"; // GET all beats (gerçek endpoint)

  // User endpoints - Backend README'ye göre düzeltilmiş
  static readonly USER_BASE = "/users";
  static readonly USER_ADMIN = "/users/admin";
  static readonly USERS_ALL = "/users/all";
  static readonly USER_PROFILE = "/users/me"; // alias (backward-compatible)

  static readonly USER_ME = "/users/me";
  static readonly USER_FCM_TOKEN = "/users/me/fcm-token";

  static readonly USER_DEVICES = "/users/me/devices";
  static readonly USER_DEVICE = "/users/me/devices"; // + "/{deviceId}" ile PUT/DELETE

  static readonly USER_SONGS = "/users/me/songs";

  // Legacy (istersen ayrı dosyada da tutabilirsin)
  static readonly USER_DEVICE_LEGACY = "/users/me/device";
  static readonly USER_ASSIGNED_SONG_LEGACY = "/users/me/assigned-song";

  // Admin actions on specific user
  static readonly USER_DEVICE_ADMIN = "/users"; // + "/{userId}/device"
  static readonly USER_ASSIGNED_SONG_ADMIN = "/users"; // + "/{userId}/assigned-song"

  // Song Types endpoints - Gerçek API'ye göre düzeltildi
  static readonly SONG_TYPES = "/song-types"; // GET all song types (gerçek endpoint)

  // Converter endpoints - Guitar Pro to DRUMLY conversion
  static readonly CONVERTER_GUITAR_PRO = "/converter/guitar-pro"; // POST convert
  static readonly CONVERTER_VALIDATE = "/converter/guitar-pro/validate"; // POST validate

  // Auth endpoints
  static readonly AUTH_LOGIN = "/auth/login";
  static readonly AUTH_LOGOUT = "/auth/logout";
  static readonly AUTH_VERIFY = "/auth/verify";

  // Health endpoints (no auth)
  static readonly HEALTH = "/health";

  // Admin endpoints - Flask backend
  static readonly ADMIN_SET_CLAIM = "/admin/set-admin-claim"; // POST - Admin yetkisi ver
  static readonly ADMIN_REMOVE_CLAIM = "/admin/remove-admin-claim"; // POST - Admin yetkisi kaldır
  static readonly ADMIN_CHECK = "/admin/check-admin"; // GET - Admin kontrolü
  static readonly ADMIN_LIST = "/admin/list-admins"; // GET - Tüm admin kullanıcıları listele
} // API configuration
export const API_CONFIG = {
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
  retryAttempts: 3,
  retryDelay: 1000,
} as const;
